import React, { useState } from "react";
import "./AnalyticsFilterDropdown.css";

const retailers = ["Amazon", "Flipkart", "D2C"];
const dateRanges = ["Last 7 days", "Last 30 days", "This Month", "Custom"];

const AnalyticsFilterDropdown = ({ onFiltersChange }) => {
  const [open, setOpen] = useState(false);
  const [selectedRetailers, setSelectedRetailers] = useState([]);
  const [selectedDates, setSelectedDates] = useState([]);
  const [customDate, setCustomDate] = useState({ start: "", end: "" });

  const toggleRetailer = (name) => {
    setSelectedRetailers((prev) =>
      prev.includes(name) ? prev.filter((r) => r !== name) : [...prev, name]
    );
  };

  const toggleDateRange = (range) => {
    setSelectedDates((prev) =>
      prev.includes(range) ? prev.filter((d) => d !== range) : [...prev, range]
    );
  };

  const handleApply = () => {
    let filters = [
      ...selectedRetailers.map((r) => ({ type: "Retailer", value: r })),
      ...selectedDates.map((d) => ({ type: "Date", value: d })),
    ];

    // Include custom date range if set
    if (selectedDates.includes("Custom") && customDate.start && customDate.end) {
      filters.push({ type: "CustomDate", value: { start: customDate.start, end: customDate.end } });
    }

    onFiltersChange && onFiltersChange(filters);
    setOpen(false);
  };

const handleRemoveFilter = (filter) => {
  if (filter.type === "Retailer") {
    setSelectedRetailers((prev) => prev.filter((r) => r !== filter.value));
  }

  if (filter.type === "Date") {
    setSelectedDates((prev) => prev.filter((d) => d !== filter.value));
  }

  if (filter.type === "CustomDate") {
    // Remove both the custom date range and "Custom" from selectedDates
    setSelectedDates((prev) => prev.filter((d) => d !== "Custom"));
    setCustomDate({ start: "", end: "" });
  }

  // Update parent filters
  onFiltersChange &&
    onFiltersChange([
      ...selectedRetailers
        .filter((r) => r !== (filter.type === "Retailer" ? filter.value : null))
        .map((r) => ({ type: "Retailer", value: r })),
      ...selectedDates
        .filter((d) => d !== (filter.type === "Date" ? filter.value : null))
        .filter((d) => d !== (filter.type === "CustomDate" ? "Custom" : null))
        .map((d) => ({ type: "Date", value: d })),
    ]);
};


  return (
    <div className="analytics-filter-dropdown">
      <div className="filter-header" onClick={() => setOpen(!open)}>
        Filters ▼
      </div>

      {open && (
        <div className="filter-menu">
          {/* Retailers Section */}
          <div className="filter-section">
            <div className="section-title">Retailers</div>
            {retailers.map((r) => (
              <label key={r}>
                <input
                  type="checkbox"
                  checked={selectedRetailers.includes(r)}
                  onChange={() => toggleRetailer(r)}
                />
                {r}
              </label>
            ))}
          </div>

          {/* Date Ranges Section */}
          <div className="filter-section">
            <div className="section-title">Date Ranges</div>
            {dateRanges.map((d) => (
              <label key={d}>
                <input
                  type="checkbox"
                  checked={selectedDates.includes(d)}
                  onChange={() => toggleDateRange(d)}
                />
                {d}
              </label>
            ))}

            {/* Custom Date Inputs */}
            {selectedDates.includes("Custom") && (
              <div className="custom-date-inputs">
                <input
                  type="date"
                  value={customDate.start}
                  onChange={(e) => setCustomDate({ ...customDate, start: e.target.value })}
                />
                <span> to </span>
                <input
                  type="date"
                  value={customDate.end}
                  onChange={(e) => setCustomDate({ ...customDate, end: e.target.value })}
                />
              </div>
            )}
          </div>

          <button className="apply-btn" onClick={handleApply}>Apply</button>
        </div>
      )}

      {/* Selected Filters */}
      <div className="selected-filters">
        {[...selectedRetailers.map(r => ({ type: "Retailer", value: r })), 
          ...selectedDates.filter(d => d !== "Custom").map(d => ({ type: "Date", value: d })), 
          ...(customDate.start && customDate.end ? [{ type: "CustomDate", value: customDate }] : [])
        ].map((f, i) => (
          <div key={i} className="filter-pill">
            {f.type === "CustomDate" ? `Custom: ${f.value.start} → ${f.value.end}` : `${f.type}: ${f.value}`} 
            <span className="remove-pill" onClick={() => handleRemoveFilter(f)}>×</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AnalyticsFilterDropdown;
